import React, {useState, useRef, useEffect} from 'react';
import './../styles.css';
import {Link} from 'react-router-dom';

function MapSketch({mainConfig, itemOver}){
    
    //TODO: Mejorar reescalado de mapa.

    useEffect(() => {
        
    }); 
    
    const config = mainConfig? mainConfig: 
    {
        jsonPaths:[], 
        scale:5
    };
    const tag = useRef(null);
    const {jsonPaths} = config;
    const scale = config.scale / 10;
    const translateX = 0 - (65 * config.scale);
    const translateY = 0 - (407 * config.scale);
    const svgWidth = (112 * config.scale) + (config.padding*2);
    const svgHeight = (120 * config.scale) + (config.padding*2);
    const regionSelected = itemOver.regionSelected;
    const pathSelected  = itemOver.pathSelected;

    const overPath = (event, parent, path) => {
        tag.current.style.left = event.pageX - tag.current.getClientRects()[0].width / 2 + "px";
        tag.current.style.top = event.pageY - tag.current.getClientRects()[0].height + "px";
        tag.current.style.opacity = "1";
        tag.current.innerHTML = path.name;
        const region = {
            ...parent,
            pathSelected:path.id
        };
        config.overPath(region);
    }
    
    const defineColor = (parent, path) => {

        let color = config.colorPath.default;
        if(path.id === pathSelected){
            return color = config.colorPath.primary;
        }else if(parent.id === regionSelected){
            return color =  config.colorPath.secondary;
        }   
        
        return color;
    }

    const leavePath = () => {
        tag.current.style.opacity = "0";
        config.leavePath();
    }

    return (
        <div>
            <div className="tag-1" ref={tag}></div>
            <svg style={{flexShrink:0, padding:`${config.padding}px 0px 0px ${config.padding}`}} width={`${svgWidth}`} height={`${svgHeight}`} id="svg2" version="1.1">
                <g transform={`translate(${translateX}, ${translateY}) scale(${scale})`}>
                    {
                        jsonPaths.map((parent) => {
                            return (
                                parent.paths.map(path => {
                                    return <Link style={{WebkitTouchCallout:"none"}} to={"/iniciativa/formulario1/"} key={path.id} onClick={() => {
                                        config.clickPath(parent);
                                        localStorage.removeItem('currentPageInitiative');
                                    }}>
                                        <path style={{fill:defineColor(parent, path)}} className="mapPath" d={path.points} id={path.id} onMouseEnter={(event) => overPath(event, parent, path)} onMouseLeave={() => leavePath()}/>
                                    </Link>
                                })
                                
                            )
                        })
                    }
                </g>
            </svg>
            <div className="row m-0 justify-content-around">
                {<img alt={""} src={require('./../../../assets/img/logo-valledelcauca.png')} style={{width:220, objectFit:"contain"}}/>}
                {<img alt={""} src={require('./../../../assets/img/logo.png')} style={{width:120, objectFit:"contain"}}/>}
                {<img alt={""} src={require('./../../../assets/img/logo-departamento-planeacion.jpg')} style={{width:220, objectFit:"contain"}}/>}
            </div>
        </div>
    )
}

export default MapSketch;